import {Component, OnInit} from '@angular/core';
import {SeoService} from "../../services/seo.service";
import {TranslateService} from "@ngx-translate/core";
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';


/**
 * Terms Conditions Component
 *
 * @author Fran Aragon
 */
@Component({
    selector: 'app-termsconditions',
    templateUrl: './termsconditions.component.html',
    styleUrls: []
})
export class TermsconditionsComponent implements OnInit {

    /**
     * SEO Content
     */
    private seo_content;

    /**
     * Set SEO Contents using SeoService
     */



    constructor(private seoService: SeoService,
                private translate: TranslateService,
                private router: Router,
                private authService: AuthService) {

        const SeoTitle: any = this.translate.instant('Seo.Title');
        const SeoDesc: any = this.translate.instant('Seo.Desc');
        const SeoKeywords: any = this.translate.instant('Seo.Keywords');

        this.seo_content = {
            "title" : SeoTitle,
            "desc" : SeoDesc,
            "keywords" : SeoKeywords
        };

        //this.seoService.setSeoPage(this.seo_content.title, this.seo_content.desc, this.seo_content.keywords);
    }

    /**
     * On init component, call chat switcher
     */
    ngOnInit() {
    }


}


